import {differenceBy, createReducer, combineReducers} from 'helpers';

const files = createReducer([], {
  EXPORTED_FILES: (state, { files = [] }) => {
    return files.filter(file => parseInt(file.size));
  },
  EXPORTED_FILES_REMOVE: (state, { files }) => {
    return differenceBy(state, files, 'name');
  },
});

const status = createReducer('idle', {
  EXPORTED_FILES_REQUEST: () => 'pending',
  EXPORTED_FILES: () => 'idle',
});

export const exported = combineReducers({ status, files });
